import { RouteComponentProps, withRouter } from "react-router-dom";
import { connect, ConnectedProps } from "react-redux";
import { State } from "../../state";
import React, { Component } from "react";
import ApiTable from "../../components/ApiTable";
import { LightThemeTable } from "../../components/LightThemeTable";
import Dropdown from "../../components/Dropdown";
import {fetchProductDistributionComparison, fetchProductDistributionFilters, fetchProductDistributionInfo} from "../../state/product-distribution-report";
import ItemSelect from "components/ItemSelect";
import debounce from "lodash/debounce";

interface FilterTypeData {
  type: string;
  data: {
    header: string;
    values: string[];
  }[];
}

type ReduxProps = ConnectedProps<typeof connecter> & RouteComponentProps;
type ProductDistributionProps = ReduxProps & ProductDistProps;
  interface ProductDistProps{
  selectedProjectId: number;
  selectedStores: number[];
  projectId:number;
};

const controllersStyle: React.CSSProperties = {
  display: "flex",
  flexDirection: "row",
  gap: "12px",
  height: "100%",
  minHeight: "100%",
  justifyContent: "space-between",
  alignItems: "center",
};

const lineSeparatorCss: React.CSSProperties = {
  height: "1px",
  width: "100%",
  backgroundColor: "#53598D26",
  margin: "5px auto",
};

const reportContainerCss: React.CSSProperties = {
  height: "400px",
  overflow: "auto",
};

const chartContentCSS: React.CSSProperties = {
  display: "flex",
  width: "100%",
};

const controllerDropdownStyle: React.CSSProperties = {
  display: "flex",
  justifyContent: "space-between",
};

const loadingContainerStyle: React.CSSProperties = {
  display: "flex",
  flexDirection: "column" as const,
  alignItems: "center",
  justifyContent: "center",
  gap: "16px",
  minHeight: "300px",
};

const spinnerStyle: React.CSSProperties =  {
  width: "48px",
  height: "48px",
  border: "4px solid #e5e7eb",
  borderTop: "4px solid #f59e0b",
  borderRadius: "50%",
  animation: "spin 1s linear infinite",
};

type ProductDistributionState = {
  manufacturerBrand: string[];
  categorySubcategory: string[];
  packageSize?: string;
  dataLoaded?: boolean;
  page: number;
  pageSize: number;
  sortField: string;
  sortOrder: 'asc' | 'desc';
  searchFields: Record<string, string>;
}

class ProductDistribution extends Component<ProductDistributionProps, ProductDistributionState> {
  state: ProductDistributionState = {
    manufacturerBrand: [],
    categorySubcategory: [],
    packageSize: undefined,
    dataLoaded: false,
    page: 1,
    pageSize: 100,
    sortField: '',
    sortOrder: 'asc' as 'asc' | 'desc',
    searchFields: {},
  };

  async componentDidMount() {
    const { projectId, selectedProjectId, selectedStores } = this.props;
    const { manufacturerBrand, categorySubcategory, packageSize } = this.state;
    this.props.fetchProductDistributionFilters(projectId, "all", "all");

    if (selectedProjectId === -1) {
      this.loadProjectData(projectId,selectedStores);
      // this.props.fetchProductDistributionFilters(projectId,"manufacturer","undefined");
    } else {
      const formattedFilters = {
        brand: manufacturerBrand,
        subCategory: categorySubcategory?.join(","),
        packageGroup: packageSize,
      };
      this.props.fetchProductDistributionInfo(projectId, formattedFilters, this.getPaginationParams(), selectedStores, selectedProjectId);
    }
  }

  componentDidUpdate(prevProps: ProductDistributionProps, prevState: ProductDistributionState) {
    const { projectId, selectedProjectId, selectedStores } = this.props;
    const { manufacturerBrand, categorySubcategory, packageSize } = this.state;

    const prevStores = prevProps.selectedStores || [];
    const currStores = selectedStores || [];
    const storesChanged =
      JSON.stringify(prevStores.sort()) !== JSON.stringify(currStores.sort());

    if (prevProps.selectedProjectId !== selectedProjectId || storesChanged) {
      if (selectedProjectId === -1) {
        this.loadProjectData(projectId,selectedStores);
      } else {
        const formattedFilters = {
          brand: manufacturerBrand,
          subCategory: categorySubcategory,
          packageGroup: packageSize,
        };

        this.props.fetchProductDistributionInfo(
          projectId,
          formattedFilters,
          this.getPaginationParams(),
          selectedStores,
          selectedProjectId
        );
      }
    }
    const { page, pageSize, sortField, sortOrder, searchFields } = this.state;
    // console.log(" Sending searchFields to API:", searchFields);
    // Check if filters, pagination, sort, or search changed
    if (
      prevState.manufacturerBrand !== manufacturerBrand ||
      prevState.categorySubcategory !== categorySubcategory ||
      prevState.packageSize !== packageSize ||
      prevState.page !== page ||
      prevState.pageSize !== pageSize ||
      prevState.sortField !== sortField ||
      prevState.sortOrder !== sortOrder ||
      prevState.searchFields !== searchFields
    ) {
      const filters = {
        brand: manufacturerBrand,
        subCategory: categorySubcategory,
        packageGroup: packageSize,
      };

      if (selectedProjectId === -1) {
        this.props.fetchProductDistributionInfo(projectId, filters, this.getPaginationParams(), selectedStores, -1);
      } else {
        const formattedFilters = {
          brand: manufacturerBrand,
          subCategory: categorySubcategory,
          packageGroup: packageSize,
        };
        this.props.fetchProductDistributionInfo(
          projectId,
          formattedFilters,
          this.getPaginationParams(),
          selectedStores,
          selectedProjectId
        );
      }
    }
  }

  loadProjectData = async (selectedProjectId: number,selectedStores:any) => {
    try {
      // const { manufacturerBrand, categorySubcategory, packageSize, sort, size, page, searchTerm } = this.state;

      // const filters = {
      //   brand: manufacturerBrand,
      //   subCategory: categorySubcategory,
      //   packageGroup: packageSize,
      // };

      // const paginationParams = {
      //   page,
      //   size,
      //   sort,
      //   searchTerm,
      // };
      const { manufacturerBrand, categorySubcategory, packageSize } = this.state;
      const formattedFilters = {
        brand: manufacturerBrand,
        subCategory: categorySubcategory?.join(","),
        packageGroup: packageSize,
      };

      this.props.fetchProductDistributionInfo(selectedProjectId, formattedFilters, this.getPaginationParams(), selectedStores, -1);
    } catch (error) {
      console.error("Error loading project data:", error);
    }
  };

  loadComparisonProjectData = async (
    baseProjectId: number,
    comparisonProjectId: number,
    storeIds: number[],
    filters?: { brand?: string; packageGroup?: string; subCategory?: string }
  ) => {
    try {
      this.props.fetchProductDistributionInfo(
        baseProjectId,
        filters,
        this.getPaginationParams(),
        storeIds,
        comparisonProjectId
      );
    } catch (error) {
      console.error("Error loading comparison data:", error);
    }
  };

  handleSearch = debounce((field: string, value: string) => {
    if (field === 'product_nm') {
    this.setState(prevState => ({
      searchFields: { ...prevState.searchFields, [field]: value },
      page: 1,
    }));
    }
  }, 400);

  handleSort = (field: string, order: 'asc' | 'desc') => {
    this.setState({ sortField: field, sortOrder: order, page: 1 });
  };

  getPaginationParams = () => {
    const { page, pageSize, sortField, sortOrder, searchFields } = this.state;
    return {
      page: page-1,
      size: pageSize,
      sort: sortField ? `${sortField}.${sortOrder}` : undefined,
      search: searchFields,
    };
  };

  handlePageChange = (page: number, pageSize: number) => {
    this.setState({ page, pageSize });
  };

  render() {
    // let lightTableData:any = [];
    const { selectedProjectId, selectedStores, content, comparisonData, loading } = this.props;
    const { manufacturerBrand, categorySubcategory, packageSize, } = this.state;
        const isBase = selectedProjectId === -1;

const dataSource = isBase
  ? content?.productDistribution
  : comparisonData?.productDistribution;

const hasDataLoaded = dataSource !== undefined;
const lightTableData = dataSource ?? [];

const isInitialLoad = loading && !hasDataLoaded;
const { page, pageSize, sortField, sortOrder, searchFields } = this.state;

const displayData = lightTableData;
const total = isBase ? (content?.totalCount || 0) : (comparisonData?.totalCount || 0);

    const { filters } = this.props;
    // if (selectedProjectId === -1 ) {
    //   lightTableData = content['productDistribution'] ?? [];
    // } else {
    //   lightTableData = comparisonData["productDistribution"] ?? [];
    // }

    const truncate = (value: any, max: number = 3) => {
      if (value === null || value === undefined) return value;
      const str = String(value);
      return str.length > max ? `${str.slice(0, max)}…` : str;
    };

    const renderTruncatedWithTooltip = (value: any, max: number = 3, suffix: string = "%") => {
      if (value === null || value === undefined) return value;
      const str = String(value);
      const truncated = truncate(str, max);
      const display = suffix ? `${truncated}${suffix}` : truncated;
      const title = suffix ? `${str}${suffix}` : str;
      return <span title={title}>{display}</span>;
    };
    const manufacturerBrandOptions: FilterTypeData[] = filters?.brand || []

    const categorySubcategoryOptions: FilterTypeData[] = filters?.subCategory || []

    const packageSizeOptions =
      (filters?.packageGroup || [])
        .filter((p: any) => p?.package_group)
        .map((p: any) => ({
          value: p.package_group,
          label: p.package_group,
        }));

    const lightTableColumnsAll = [
      { header: "Name", field: "product_nm", sortable: true, searchable: true, minWidth: 150 },
      { header: "Adds", field: "adds_sum", sortable: true, searchable: false, minWidth: 100 },
      { header: "Deletes", field: "deletes_sum", sortable: true, searchable: false, minWidth: 100 },
      { header: "Maintains", field: "maintains_sum", sortable: true, searchable: false, minWidth: 100 },
      { header: "Total PODs", field: "post_total_pods", sortable: true, searchable: false, minWidth: 100 },
      { header: "POD changes", field: "pod_change", sortable: true, searchable: false, minWidth: 100 },
      { header: "Distribution", field: "post_distribution", sortable: true, searchable: false, minWidth: 100, formatter: (value: string) => value ? `${Number(value).toFixed(2)}%` : '-' },
      { header: "Distro Change", field: "distro_change", sortable: true, searchable: false, minWidth: 100, formatter: (value: string) => value ? `${Number(value).toFixed(2)}%` : '-' },
      { header: "Cubic Share Post", field: "cubic_share_post", sortable: true, searchable: false, minWidth: 100,formatter: (value: string) => value ? `${Number(value).toFixed(2)}%` : '-'},
      { header: "Cubic Share Prior", field: "cubic_share_prior", sortable: true, searchable: false, minWidth: 100, formatter: (value: string) => value ? `${Number(value).toFixed(2)}%` : '-' },
      { header: "Cubic Space Post", field: "cubic_space_post", sortable: true, searchable: false, minWidth: 100,formatter: (value:string) =>
          value != null
            ? Number(value).toFixed(2)
            : "-" },
      { header: "Cubic Space Prior", field: "cubic_space_prior", sortable: true, searchable: false, minWidth: 100,formatter: (value:string) =>
          value != null
            ? Number(value).toFixed(2)
            : "-" },
      // { header: "Cubic Space Change", field: "cubic_space_change", sortable: true, searchable: false, minWidth: 100 },
      // { header: "Distribution", field: "total_distribution", sortable: true, searchable: false, minWidth: 100, formatter: (value: string) => value+'%' },
      // { header: "Distro Change", field: "distro_change", sortable: true, searchable: false, minWidth: 100,formatter: (value: string) => value+'%'},
      // { header: "Cubic Share Post", field: "cubic_share_post", sortable: true, searchable: false, minWidth: 100 ,formatter: (value: string) => value+'%'},
      // { header: "Cubic Share Prior", field: "cubic_share_prior", sortable: true, searchable: false, minWidth: 100,formatter: (value: string) => value+'%' },
      { header: "Cubic Space Change", field: "cubic_space_change", sortable: true, searchable: false, minWidth: 100,formatter: (value:string) =>
          value != null
            ? Number(value).toFixed(2)+"%"
            : "-"},
    ];

    const lightTableColumns =
      selectedProjectId !== -1
        ? lightTableColumnsAll
        : [
          lightTableColumnsAll[0],
          lightTableColumnsAll[4],
          lightTableColumnsAll[6],
          lightTableColumnsAll[8],
          lightTableColumnsAll[10]
        ];

    // const addTableColumns = [
    //   { header: "Name", field: "product_nm", sortable: true },
    //   { header: "Adds", field: "adds", sortable: true },
    //   { header: "Adds, Store%", field: "add_per_store_diff", sortable: true, formatter: (value: string) => renderTruncatedWithTooltip(value, 7, "%"), },
    //   { header: "Total PODs", field: "total_pods", sortable: true },
    //   { header: "Distribution", field: "distribution", sortable: true, formatter: (value: string) => renderTruncatedWithTooltip(value, 7, "%"), },
    // ];

    // let addTableData = [];
    // if (comparisonData && comparisonData.adds) {
    //   addTableData = comparisonData.adds;
    // }
    //
    // const deleteTableColumns = [
    //   { header: "Name", field: "product_nm", sortable: true },
    //   { header: "Deletes", field: "deletes", sortable: true },
    //   { header: "Deletes, Store%", field: "delete_per_store_diff", sortable: true, formatter: (value: string) => renderTruncatedWithTooltip(value, 7, "%"),},
    //   { header: "Total PODs", field: "total_pods", sortable: true },
    //   { header: "Distribution", field: "distribution", sortable: true, formatter: (value: string) => renderTruncatedWithTooltip(value, 7, "%"), },
    // ];

    // let deleteTableData = [];
    // if (comparisonData && comparisonData.deletes) {
    //   deleteTableData = comparisonData.deletes;
    // }

    const handleBrandChange = (brand: string) => {
      // console.log("Selected brand:", brand);
    };

    return (
      <div className="reset-recap-container">
        <style>
          {`
            .chart-styles table thead tr th {
                position: sticky !important;
                top: 0 !important;
                z-index: 1;
                background-color: #F9FAFB;
            }
            .chart-styles > div > div {
                max-height: calc(100vh - 330px) !important;
            }
            .chart-styles table tbody tr td {
                height: 45px !important;
                vertical-align: middle;
                min-width: 100px;
            }
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
        <div className="store-summary-header">
          <div style={controllersStyle}>
            <div>
              Product Distribution Report
              {/* <div className="reset-recap-sub-header">Highlights space efficiency to inform portfolio and space allocation decisions.</div> */}
            </div>
            <div className="product-filters" style={controllerDropdownStyle}>
              <div className="filter-block" style={{ minWidth: "200px", marginRight: "8px" }}>
                <div className="header-controller-dropdown">
                  Manufacturer-Brand
                </div>
                <div>
                  <ItemSelect
                    value={this.state.manufacturerBrand}
                    data={manufacturerBrandOptions}
                    onChange={(val: string | string[]) => {
                      const selectedBrands = Array.isArray(val) ? val : [val];
                    const allBrands = manufacturerBrandOptions.flatMap((type: FilterTypeData) =>
                        type.data.flatMap(d => d.values)
                      );
                      const isSelectAll = selectedBrands.length === allBrands.length;

                      // Find manufacturers for selected brands
                      const selectedManufacturers = manufacturerBrandOptions
                        .flatMap((type: FilterTypeData) => type.data)
                        .filter((d) => d.values.some((v: string) => selectedBrands.includes(v)))
                        .map((d) => d.header);

                      this.setState({
                        manufacturerBrand: selectedBrands,
                        categorySubcategory: [],
                        packageSize: undefined,
                      });

                      if (isSelectAll || selectedManufacturers.length === 0)  {
                        this.props.fetchProductDistributionFilters(
                          this.props.projectId,
                          "all",
                          "all"
                        );
                      } else {
                        this.props.fetchProductDistributionFilters(
                          this.props.projectId,
                          "category",
                          selectedManufacturers.join(",")
                        );
                        this.props.fetchProductDistributionFilters(
                          this.props.projectId,
                          "package",
                          "all"
                        );
                      }
                    }}
                    multiSelect={true}
                    isDisabled={false}
                    hideHeader={false}
                  />
                </div>
              </div>
              <div className="filter-block" style={{ minWidth: "200px", marginRight: "8px" }}>
                <div className="header-controller-dropdown">
                  Category-Subcategory
                </div>
                <div>
                  <ItemSelect
                    value={this.state.categorySubcategory}
                    data={categorySubcategoryOptions}
                    onChange={(val: string | string[]) => {
                      const values = Array.isArray(val) ? val : [val];

                        const allValues = categorySubcategoryOptions.flatMap((type: FilterTypeData) =>
                          type.data.flatMap(d => d.values)
                        );

                        const isSelectAll = values.length === allValues.length;

                      this.setState({
                        categorySubcategory: values,
                        packageSize: undefined,
                      });

                      const selectedManufacturers = manufacturerBrandOptions
                            .flatMap((type: FilterTypeData) => type.data)
                            .filter((d) => d.values.some((v: string) => manufacturerBrand.includes(v)))
                            .map((d) => d.header);
                      if (values.length === 0) {
                        if (manufacturerBrand.length > 0) {
                        if (selectedManufacturers.length > 0) {
                        this.props.fetchProductDistributionFilters(
                          this.props.projectId,
                          "category",
                          selectedManufacturers
                        );
                        }
                        } else
                          this.props.fetchProductDistributionFilters(
                            this.props.projectId,
                            "all",
                            "all"
                        );
                      } else {
                        this.props.fetchProductDistributionFilters(
                          this.props.projectId,
                          "package",
                          values.join(",")
                        );
                      }
                    }}
                    multiSelect={true}
                    isDisabled={false}
                  />
                </div>
              </div>
              <div className="filter-block" style={{ minWidth: "200px", marginRight: "8px" }}>
                <div className="header-controller-dropdown">
                  Package Size
                </div>
                <div>
                  <Dropdown
                    value={
                      packageSizeOptions.find(
                        (o: any) => o.value === packageSize
                      ) || null
                    }
                    options={packageSizeOptions}
                    onChange={(selected: any) =>
                      this.setState({ packageSize: selected?.value })
                    }
                    placeholder="All"
                    isDisabled={false}
                    isSearchable
                    controlStyles={{ minHeight: 44, borderRadius: "16px" }}
                    noShadow={true}
                    hasDefaultAll={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style={lineSeparatorCss} />
        <div className="reset-recap-chart-container" style={reportContainerCss}>
          <div className="charts-row" style={chartContentCSS}>
            <div className="chart-styles" style={{ flex: 1, minWidth: 0, overflow: "auto" }}>
              {/* <div className="chart-headers">
                Product Distribution
              </div>
              <div className="chart-sub-header">
                Highlights space efficiency to inform portfolio and space allocation decisions.
              </div> */}
              {/* {isInitialLoad ? (
                <div style={loadingContainerStyle}>
                  <div style={spinnerStyle}></div>
                </div>
              ) : ( */}
                <ApiTable
                  data={displayData}
                  columns={lightTableColumns}
                  total={total}
                  page={page}
                  pageSize={pageSize}
                  pageSizeOptions={[100, 150, 200]}
                  loading={loading || !hasDataLoaded}
                  onSearch={this.handleSearch}
                  onSort={this.handleSort}
                  onPageChange={this.handlePageChange}
                  onRowClick={(row) => console.log("Clicked row:", row)}
                />
              {/* )} */}
            </div>
          </div>

          {/*{selectedProjectId !== -1 && (*/}
          {/*  <div className="charts-row" style={chartContentCSS}>*/}
          {/*    <div className="chart-styles" style={{ flex: 1, minWidth: 0 }}>*/}
          {/*      <div className="chart-headers">*/}
          {/*        Adds*/}
          {/*      </div>*/}
          {/*      <div className="chart-sub-header">*/}
          {/*        Underlying metrics to validate insights and guide action.*/}
          {/*      </div>*/}
          {/*      {loading || !hasDataLoaded ? (*/}
          {/*        <div style={loadingContainerStyle}>*/}
          {/*          <div style={spinnerStyle}></div>*/}
          {/*        </div>*/}
          {/*      ) : (*/}
          {/*        <LightThemeTable*/}
          {/*          data={addTableData}*/}
          {/*          columns={addTableColumns}*/}
          {/*          defaultPageSize={10}*/}
          {/*          pageSizeOptions={[10, 25, 50]}*/}
          {/*          showPagination={true}*/}
          {/*          isLoading={loading}*/}
          {/*          onPageChange={(page: number, size: number) => console.log(`Page: ${page}, Size: ${size}`)}*/}
          {/*          onClickOnRow={(row: any) => console.log("Clicked row:", row)}*/}
          {/*        />*/}
          {/*      )}*/}
          {/*    </div>*/}
          {/*    <div className="chart-styles" style={{ flex: 1, minWidth: 0 }}>*/}
          {/*      <div className="chart-headers">*/}
          {/*        Deletes*/}
          {/*      </div>*/}
          {/*      <div className="chart-sub-header">*/}
          {/*        Underlying metrics to validate insights and guide action.*/}
          {/*      </div>*/}
          {/*      {loading || !hasDataLoaded ? (*/}
          {/*        <div style={loadingContainerStyle}>*/}
          {/*          <div style={spinnerStyle}></div>*/}
          {/*        </div>*/}
          {/*      ) : (*/}
          {/*        <LightThemeTable*/}
          {/*          data={deleteTableData}*/}
          {/*          columns={deleteTableColumns}*/}
          {/*          defaultPageSize={10}*/}
          {/*          pageSizeOptions={[10, 25, 50]}*/}
          {/*          showPagination={true}*/}
          {/*          isLoading={loading}*/}
          {/*          onPageChange={(page: number, size: number) => console.log(`Page: ${page}, Size: ${size}`)}*/}
          {/*          onClickOnRow={(row: any) => console.log("Clicked row:", row)}*/}
          {/*        />*/}
          {/*      )}*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*)}*/}
        </div>
      </div>
    );
  }
}

const connecter = connect(
  (state: State) => ({
    filters: state.productDistributionDetails.filters,
    content: state.productDistributionDetails.content,
    comparisonData: state.productDistributionDetails.comparisonData,
    loading: state.productDistributionDetails.loading,
  }),
  {fetchProductDistributionInfo,fetchProductDistributionFilters, fetchProductDistributionComparison}
);

export default connecter(withRouter(ProductDistribution));
